import React from "react";
import {
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

const Searchbar = ({
  value,
  onChange,
  onEnter,
  onClear,
  placeholder = "Search...",
}) => {
  return (
    <TextField
      placeholder={placeholder}
      value={value}
      size="small"
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          onEnter && onEnter(e.target.value);
        }
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: "#9e9e9e" }} />
          </InputAdornment>
        ),
        endAdornment: value && (
          <InputAdornment position="end">
            <IconButton size="small" onClick={onClear}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
      sx={{
        width: "100%",
        maxWidth: "480px",
        "& .MuiOutlinedInput-root": {
          borderRadius: "24px",
          width: "480px",
          height: "42px",
          backgroundColor: "#ffffff",
          "& fieldset": {
            borderColor: "#B8B8B8",
          },
          "&:hover fieldset": {
            borderColor: "#B8B8B8",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#B8B8B8",
          },
        },
        "@media (max-width: 768px)": {
          maxWidth: "100%",
          "& .MuiOutlinedInput-root": {
            height: "36px",
          },
        },
      }}
    />
  );
};

export default Searchbar;